import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@core/services/api.service';

const routes = {
  insert: `/usuarios`,
  edit: (idUsuario: number) => `/usuarios/${idUsuario}`,
  consult: `/usuarios/consultar`,
  consultId: (idUsuario: number) => `/usuarios/${idUsuario}`,
  delete: (idUsuario: number) => `/usuarios/${idUsuario}`
}
@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor(private apiService: ApiService) { }

  cadastrar(obj: any) {
    return this.apiService.post(routes.insert, obj);
  }

  editar(idUsuario: number, obj: any) {
    return this.apiService.put(routes.edit(idUsuario), obj);
  }

  consultar(obj: any, page: number, pageSize: number) {
    let params = new HttpParams();
    params = params.append('size', pageSize);
    params = params.append('page', page - 1);
    return this.apiService.post<any>(routes.consult, obj, undefined, undefined, params);
  }

  consultarPorId(idUsuario: number) {
    return this.apiService.get<any>(routes.consultId(idUsuario));
  }

  deletarUsuario(idUsuario: number) {
    return this.apiService.delete(routes.delete(idUsuario));
  }
}
